import {CSSProperties} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {css as pandaCss, cx} from "@panda/css";

import {elevation} from "@pg-design/elevation";
import {borderRadius} from "@pg-design/helpers-css";
import {getThemeBreakpoint} from "@pg-design/styles-strings";

export const OfferBoxBase = styled.div`
    position: relative;
    ${elevation(2)}
    width: 100%;
    height: 100%;
    min-width: 288px;
    max-width: 375px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    transition: box-shadow 0.2s ease-in-out;
    ${borderRadius(2, 2, 2, 2)}

    &:hover {
        ${elevation(3)}
    }
`;

export const offerBoxImgWrapperStyle = css`
    height: 20.4rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        height: 24.6rem;
    }
`;

export const offerBoxImgStyle: CSSProperties = {
    objectFit: "cover",
    height: "100%",
    width: "100%"
};

// Progressive migration for panda css to not break other OfferBoxBase
const offerBoxBasePandaStyles = pandaCss({
    boxShadow: "var(--shadows-2)",
    width: "100%",
    height: "100%",
    minWidth: "288px",
    maxWidth: "375px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "var(--colors-white)",
    transition: "box-shadow 0.2s ease-in-out",
    borderRadius: "var(--radii-2)"
});

export const OfferBoxBasePanda = ({children, className}: React.PropsWithChildren<{className?: string}>) => (
    <div className={cx(offerBoxBasePandaStyles, className)}>{children}</div>
);
import {CSSProperties} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {css as pandaCss, cx} from "@panda/css";

import {elevation} from "@pg-design/elevation";
import {borderRadius} from "@pg-design/helpers-css";
import {getThemeBreakpoint} from "@pg-design/styles-strings";

export const OfferBoxBase = styled.div`
    position: relative;
    ${elevation(2)}
    width: 100%;
    height: 100%;
    min-width: 288px;
    max-width: 375px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    transition: box-shadow 0.2s ease-in-out;
    ${borderRadius(2, 2, 2, 2)}

    &:hover {
        ${elevation(3)}
    }
`;

export const offerBoxImgWrapperStyle = css`
    height: 20.4rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        height: 24.6rem;
    }
`;

export const offerBoxImgStyle: CSSProperties = {
    objectFit: "cover",
    height: "100%",
    width: "100%"
};

// Progressive migration for panda css to not break other OfferBoxBase
const offerBoxBasePandaStyles = pandaCss({
    boxShadow: "var(--shadows-2)",
    width: "100%",
    height: "100%",
    minWidth: "288px",
    maxWidth: "375px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "var(--colors-white)",
    transition: "box-shadow 0.2s ease-in-out",
    borderRadius: "var(--radii-2)"
});

export const OfferBoxBasePanda = ({children, className}: React.PropsWithChildren<{className?: string}>) => (
    <div className={cx(offerBoxBasePandaStyles, className)}>{children}</div>
);
